import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const setEnforcePermissionChecksOnSiteEnabled = (enabled: boolean): Promise<void> =>
	performPutRequest('/rest/polaris/edition/enforce-permission-checks', {
		body: JSON.stringify({
			enabled,
		}),
	});
